export const XENTRY_INTEGRATION_CODE = 'MERCEDES_XENTRY';
